<template>
  <nav>
    <AlertMessages v-if="alertValue" :alert-type="alertType" :alert-msg="alertMsg" @reset="alertValue = false" />
    <v-row no-gutters>
      <v-col :cols="mobile() ? '12' : '11'" :class="mobile() ? '' : 'mx-auto'">
        <TopWorkflowPeople page="overview" />
      </v-col>
    </v-row>
    <v-row v-if="!loadingData && notDeletedWorkflowActions.length == 0" align="center">
      <v-col cols="12" sm="8" md="6" offset-sm="2" offset-md="3" align="center">
        <EmptyPage :page-title="$t('emptyWorkflowOverviewTitle')" :page-text="$t('emptyWorkflowOverviewText')"
          page-image="workflow1" />
      </v-col>
    </v-row>
    <div class="workflow-overview pb-16 px-8" v-if="!loadingData && notDeletedWorkflowActions.length > 0" :class="mobile() ? 'mt-4' : 'mt-16'">
      <v-card color="#c8f0d7" class="mx-auto rounded-lg" max-width="500px" width="100%">
        <v-row class="py-3">
          <v-col cols="12" class="">
            <v-card-subtitle class="pa-0 text-center">
              {{ $t("addPeopleToWorkflow") }}
            </v-card-subtitle>
          </v-col>
        </v-row>
      </v-card>
      <v-expansion-panels style="max-width: 500px; width: 100%" class="mx-auto" v-model="openedPanel">
        <div v-for="(item, index) in notDeletedWorkflowActions" :key="index" style="max-width: 500px; width: 100%"
          class="mx-auto pt-4 workflow-action" data-testid="workflow-action">
          <v-expansion-panel :readonly="(item.relationships['action-types'].meta.type == 'delay_duration' || item.relationships['action-types'].meta.type == 'delay_until' || (item.relationships['action-types'].meta.type == 'share_hub' && item.attributes.custom_message == null) || (item.relationships['action-types'].meta.type == 'share_activity' && item.attributes.custom_message == null) || item.relationships['action-types'].meta.type == 'remove_from_hub' || item.relationships['action-types'].meta.type == 'remove_from_activity')">
            <v-expansion-panel-header :expand-icon="(item.relationships['action-types'].meta.type == 'delay_duration' || item.relationships['action-types'].meta.type == 'delay_until' || (item.relationships['action-types'].meta.type == 'share_hub' && item.attributes.custom_message == null) || (item.relationships['action-types'].meta.type == 'share_activity' && item.attributes.custom_message == null) || item.relationships['action-types'].meta.type == 'remove_from_hub' || item.relationships['action-types'].meta.type == 'remove_from_activity') ? '' : 'mdi-menu-down'" class="pa-0" data-testid="panel-header">
              <v-icon class="broken-icon" color="error" v-if="item.attributes.is_broken && !mobile()">mdi-alert</v-icon>
              <v-row no-gutters>
                <v-col :cols="mobile() ? 12 : 2" class="pa-3" :class="mobile() ? 'pb-0' : ''">
                  <v-icon v-if="item.relationships['action-types'].meta.type == 'share_hub' || item.relationships['action-types'].meta.type == 'share_activity'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30">
                    mdi-share-variant
                  </v-icon>
                  <v-icon v-else-if="item.relationships['action-types'].meta.type == 'delay_duration'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30">
                    mdi-timer-sand-complete
                  </v-icon>
                  <v-icon v-else-if="item.relationships['action-types'].meta.type == 'delay_until'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30">
                    mdi-calendar-today
                  </v-icon>
                  <v-icon v-else-if="item.relationships['action-types'].meta.type == 'custom_message'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30">
                    mdi-email-outline
                  </v-icon>
                  <v-icon v-if="item.relationships['action-types'].meta.type == 'remove_from_hub' || item.relationships['action-types'].meta.type == 'remove_from_activity'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30">
                    mdi-account-remove-outline
                  </v-icon>
                  <v-icon v-else-if="item.relationships['action-types'].meta.type == 'certificate'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30">
                    mdi-school-outline
                  </v-icon>
                  <v-icon v-else-if="item.relationships['action-types'].meta.type == 'event'" style="background-color: #e3e3e3;" color="white" class="pa-3 rounded-lg" size="30">
                    mdi-calendar-today
                  </v-icon>
                </v-col>
                <v-col :cols="mobile() ? 12 : 10" class="pa-3">
                  <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold"
                    v-if="item.relationships['action-types'].meta.type == 'share_hub'">
                    {{ $t('shareHubAction') }}
                  </v-card-title>
                  <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" 
                    v-else-if="item.relationships['action-types'].meta.type == 'share_activity'">
                    {{ $t('shareActAction') }}
                  </v-card-title>
                  <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" 
                    v-else-if="item.relationships['action-types'].meta.type == 'delay_duration'">
                    {{ $t('delayAmountOfTimeAction') }}
                  </v-card-title>
                  <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" 
                    v-else-if="item.relationships['action-types'].meta.type == 'delay_until'">
                    {{ $t('delayUntilDateAndTimeAction') }}
                  </v-card-title>
                  <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" 
                    v-else-if="item.relationships['action-types'].meta.type =='custom_message'">
                    {{ $t('sendCustomMessageAction') }} 
                  </v-card-title>
                  <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" 
                    v-else-if="item.relationships['action-types'].meta.type =='remove_from_hub'">
                    {{ $t('removeFromHubAction') }} 
                  </v-card-title>
                  <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" 
                    v-else-if="item.relationships['action-types'].meta.type =='remove_from_activity'">
                    {{ $t('removeFromActivityAction') }} 
                  </v-card-title>
                  <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" 
                    v-else-if="item.relationships['action-types'].meta.type =='certificate'">
                    {{ $t('certificateAction') }} 
                  </v-card-title>
                  <v-card-title class="pt-0 pb-2 px-0 text-left text-body-1 font-weight-bold" 
                    v-else-if="item.relationships['action-types'].meta.type =='event'">
                    {{ $t('eventAction') }} 
                  </v-card-title>

                  <v-card-subtitle v-if="item.relationships['action-types'].meta.type =='share_hub' || item.relationships['action-types'].meta.type =='share_activity' || item.relationships['action-types'].meta.type =='remove_from_hub' || item.relationships['action-types'].meta.type =='remove_from_activity'" class="py-1 px-0 text-left text-subtitle-1" :class="item.attributes.is_broken ? 'error--text': ''">
                    <span>{{ item.attributes.title }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle v-if="item.relationships['action-types'].meta.type =='delay_duration'" class="py-1 px-0 text-left text-subtitle-1" :class="item.attributes.is_broken ? 'error--text': ''">
                    <span>{{ secondsToDays(Number(item.attributes.delay_duration)) }} days, {{ secondsToHours(Number(item.attributes.delay_duration)) }} hours, {{ secondsToMinutes(Number(item.attributes.delay_duration)) }} minutes</span>
                  </v-card-subtitle>
                  <v-card-subtitle v-if="item.relationships['action-types'].meta.type =='delay_until'" class="py-1 px-0 text-left text-subtitle-1" :class="item.attributes.is_broken ? 'error--text': ''">
                    <span>
                      {{ moment(new Date(item.attributes.delay_till_time)).format('YYYY-MM-DD') }} 
                      {{ moment(new Date(item.attributes.delay_till_time)).format('HH:mm') }}
                    </span>
                  </v-card-subtitle>
                  <v-card-subtitle v-if="item.relationships['action-types'].meta.type =='custom_message'" class="py-1 px-0 text-left text-subtitle-1" :class="item.attributes.is_broken ? 'error--text': ''">
                    <span>{{ $t('viaMail') }}</span>
                  </v-card-subtitle>
                  <v-card-subtitle v-if="item.relationships['action-types'].meta.type =='certificate'" class="py-1 px-0 text-left text-subtitle-1" :class="item.attributes.is_broken ? 'error--text': ''">
                    <span>{{ $t('viaMail') }}</span>
                  </v-card-subtitle>

                  <v-card-subtitle v-if="item.relationships['action-types'].meta.type =='event'" class="py-1 px-0 text-left text-subtitle-1"> 
                  <span :class="item.attributes.is_broken ? 'error--text': ''">{{ item.attributes.event_title }}</span>
                  <p class="mb-0" v-if="item.attributes.event_at != null">
                    {{ moment(new Date(item.attributes.event_at)).format('YYYY-MM-DD') }} 
                    {{ moment(new Date(item.attributes.event_at)).format('HH:mm') }}
                  </p>
                </v-card-subtitle>      
                
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="(item.relationships['action-types'].meta.type == 'share_hub' && item.attributes.custom_message) || (item.relationships['action-types'].meta.type == 'share_activity' && item.attributes.custom_message)">
              <v-row>
                <v-col cols="12">
                  <v-card outlined class="pa-4 rounded-lg overflow-y-auto" max-height="300px">
                    <p class="text-body-2 font-weight-bold mb-1">
                      {{ $t('labelMessage') }}:
                    </p>
                    <p class="text-body-2 pre-wrap" v-html="item.attributes.custom_message"></p>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-if="item.relationships['action-types'].meta.type == 'custom_message'">
              <v-row>
                <v-col cols="12">
                  <v-card outlined class="pa-4 rounded-lg overflow-y-auto" max-height="300px">
                    <p class="text-body-2 font-weight-bold mb-1">
                      {{ $t('labelSubject') }}:
                    </p>
                    <p class="text-body-2">{{ item.attributes.custom_subject }}</p>
                    <p class="text-body-2 font-weight-bold mb-1">
                      {{ $t('labelMessage') }}:
                    </p>
                    <p class="text-body-2 pre-wrap" v-html="item.attributes.custom_message"></p>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-if="item.relationships['action-types'].meta.type == 'certificate'">
              <v-row>
                <v-col cols="12">
                  <v-card outlined class="pa-4 rounded-lg overflow-y-auto" max-height="300px">
                    <p class="text-body-2 font-weight-bold mb-1">
                      {{ $t('labelSubject') }}:
                    </p>
                    <p class="text-body-2">{{ item.attributes.custom_subject }}</p>
                    <p class="text-body-2 font-weight-bold mb-1">
                      {{ $t('labelMessage') }}:
                    </p>
                    <p class="text-body-2 pre-wrap" v-html="item.attributes.custom_message"></p>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
            <v-expansion-panel-content v-if="item.relationships['action-types'].meta.type == 'event'">
              <v-row>
                <v-col cols="12">
                  <v-card outlined class="pa-4 rounded-lg overflow-y-auto" max-height="300px">
                    <p class="text-body-2 font-weight-bold mb-1">
                      {{ $t('labelSubject') }}:
                    </p>
                    <p class="text-body-2">{{ item.attributes.custom_subject }}</p>
                    <p class="text-body-2 font-weight-bold mb-1">
                      {{ $t('labelMessage') }}:
                    </p>
                    <p class="text-body-2 pre-wrap" v-html="item.attributes.custom_message"></p>
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <div v-if="item.users" 
            class="workflow-action-users" 
            data-testid="workflow-action-users"
            @click.stop="
              dialogVisiblePeopleInAction=true, 
              selectedItem=item"
          >
            <v-tooltip
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <div 
                  v-bind="attrs"
                  v-on="on">
                  <div
                    v-for="user of item.users.slice(0, 2)"
                    :key="user.id"            
                    data-testid="workflow-user"
                  >
                    <v-avatar
                      size="32"
                      style="bottom:5px;border:3px solid;"
                      class="avatar mt-n2"
                      color="white"
                    >
                      <img
                        v-if="user.avatar_thumb == null"
                        src="../../assets/user_images/profile-avatar.png"
                      >
                      <img
                        v-else
                        :src="user.avatar_thumb"
                      >
                  </v-avatar>
                </div>
                <div
                  v-if="item.meta.members > 2"
                  data-testid="workflow-user"
                >
                  <v-avatar
                    size="32"
                    style="bottom:5px;border:3px solid;"
                    class="avatar mt-n2"
                    color="white"
                  >
                    <img
                      src="../../assets/artboard.png"
                    >
                  </v-avatar>
                </div>
              </div>
            </template>
            <span>{{ $t('workflowActionUsersTooltip') }}</span>
            </v-tooltip>
          </div>
        </div>
      </v-expansion-panels>
    </div>
    <ConfirmationDialogListWorkflowActionUsers
        v-if="dialogVisiblePeopleInAction"
        :visible="dialogVisiblePeopleInAction" 
        :item="selectedItem"
        data-testid="confirmation-dialog-people-in-action" 
        @close="dialogVisiblePeopleInAction =false"
        @proceedError="showErrorMessage"

      />
    <EditButtonWithLink v-if="(role == 'booster' || role == 'space_admin') && !mobile()"
      data-testid="edit-workflow-button" rounded="xxl" :class="editButtonTextColor" :color="editButtonColor"
      :link="{ title: '', route: '/workflow/' + $route.params.id + '/edit' }" :classes="'edit-workflow'" />
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import AlertMessages from '../../components/AlertMessages'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import EditButtonWithLink from '../../components/EditButtonWithLink'
import EmptyPage from "../../components/EmptyPage";
import TopWorkflowPeople from './TopWorkflowPeople'
import { getWorkflowActionsInWorkflow, getWorkflowActionProgress } from "../../api/workflowApi";
import moment from 'moment'
import Vue from 'vue'
import ConfirmationDialogListWorkflowActionUsers from '../../components/ConfirmationDialogListWorkflowActionUsers'

Vue.prototype.moment = moment

export default {
  components: {
    AlertMessages,
    EditButtonWithLink,
    EmptyPage,
    TopWorkflowPeople,
    ConfirmationDialogListWorkflowActionUsers
  },
  mixins: [repeatedMethodsMixin],
  data() {
    return {
      alertMsg: '',
      alertType: '',
      alertValue: false,
      pageNumber: 1,
      size: 1,
      loadingData: false,
      peopleInWorkflow: 0,
      boostersInWorkflow: 0,
      isOwner: '',
      spaceId: window.$cookies.get('space_id'),
      role: localStorage.space ? JSON.parse(localStorage.space).role : '',
      editButtonColor: 'accent',
      editButtonTextColor: 'black--text',
      workflowId: this.$route.params.id,
      workflowActions: [],
      openedPanel: null,
      dialogVisiblePeopleInAction: false,
      selectedItem: {}
    }
  },
  computed: {
    notDeletedWorkflowActions() {
      return this.workflowActions.filter(
        (page) =>
          page.attributes.is_deleted == false && page.attributes.is_active == true
      );
    },
  },
  async created() {
    this.loadingData = true
    if (this.$route.params.discardChangesWorkflow) {
      this.alertMsg = i18n.t("discardChangesWorkflowSuccess");
      this.alertType = "success";
      this.alertValue = true;
    }
    if (this.$route.params.savedChangesWorkflow) {
      this.alertMsg = i18n.t("savedChangesWorkflowSuccess");
      this.alertType = "success";
      this.alertValue = true;
    }

    await this.getWorkflowActionsInWorkflow();

    await this.getWorkflowActionUsers()

    this.loadingData = false
  },
  methods: {
    async getWorkflowActionsInWorkflow() {
      try {
        const response = await getWorkflowActionsInWorkflow(this.workflowId);
        if (response.status) {
          if (response.status == 200) {
            this.workflowActions = response.data.data;
          }
        }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },

    setWorkflowProgress(response){
      for(let i = 0; i < this.notDeletedWorkflowActions.length; i++){
        if( response.action_users[this.notDeletedWorkflowActions[i].id]){
          Vue.set(this.notDeletedWorkflowActions[i], "users", response.action_users[this.notDeletedWorkflowActions[i].id]);
        }
      }
    },
    async getWorkflowActionUsers(){
      try {
        const response = await getWorkflowActionProgress(this.workflowId);
        if (response.status == 200) {
          this.setWorkflowProgress(response.data.meta);
        }
        // for(let i = 0; i < this.notDeletedWorkflowActions.length; i++){
        //   const response = await getWorkflowActionUsers(this.notDeletedWorkflowActions[i].id, 15, 1);
        //   if (response.status == 200) {
        //     Vue.set(this.notDeletedWorkflowActions[i], "users", response.data.data);
        //   }
        // }
      } catch (e) {
        if (e.response) {
          this.alertValue = true;
          this.alertType = "error";
          this.alertMsg = i18n.t("serverError");
        }
      }
    },

    showErrorMessage(){
      this.dialogVisiblePeopleInAction = false;
      this.alertValue = true;
      this.alertType = "error";
      this.alertMsg = i18n.t("serverError");
    }
  }
}
</script>
